// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","modal_content":"Modal_modal_content__-WSAd"};